export enum TipoEnvioCodigoEnum {
  ENVIO_EMAIL = 'ENVIO_EMAIL',
  ENVIO_SMS = 'ENVIO_SMS',
}
